import { useTranslations } from 'hooks/useTranslations';
import * as yup from 'yup';

export const useLoginSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    email: yup
      .string()
      .email(t('login.enterEmail.text'))
      .max(254)
      .required(t('login.enterEmail.text')),
    password: yup.string().required(t('login.enterPassword.text')),
  });
  return { schema };
};
